import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

/**
 * Cross-client SSO/SCIM state for the System Admin surface. One request for the whole page —
 * the server does the aggregation (see api/src/modules/sso/sso-estate-overview.module.mjs) so
 * this must never become a per-client fan-out.
 *
 * There is deliberately no token field to select: the server type carries counts and timestamps
 * only, never a token value, hash, or prefix.
 */
export const getSSOEstateOverview = api(async function ssoEstateOverview() {
    return await query(
        gql`
            query ssoEstateOverview {
                ssoEstateOverview {
                    generatedAt
                    clients {
                        clientId
                        clientName
                        configId
                        ssoEnabled
                        scimEnabled
                        enforceSSO
                        providerName
                        emailDomains
                        updated
                        parkedUsers
                        tokens {
                            active
                            revoked
                            lastUsedAt
                        }
                        breaker {
                            tripped
                            trippedAt
                            reason
                            deprovisionsInWindow
                            windowMinutes
                            disabled
                            unavailable
                        }
                    }
                    domains {
                        domain
                        clientId
                        clientName
                        providerName
                        ssoEnabled
                    }
                }
            }
        `,
        {},
        { returns: "ssoEstateOverview", fetchPolicy: "network-only" }
    )
})
